module.exports = __webpack_public_path__ + "img/modal-send-campaing.31a12cbf.svg";